/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box } from '@chakra-ui/react';

export const PlateEvent: React.FC<any> = ({ children, ...rest }) => (
  <Box
    background="white"
    w="100%"
    overflow="hidden"
    display="flex"
    justifyContent="space-between"
    borderColor="grayBorder"
    _first={{ borderTopRadius: 'lg' }}
    _last={{ borderBottomRadius: 'lg' }}
    _notLast={{ borderBottomWidth: '1px' }}
    {...rest}
  >
    {children}
  </Box>
);
